export default __webpack_public_path__ + "static/media/logoWhite.0d3613f0.png";